/* tslint:disable */
/* eslint-disable */
/**
 * Statistics API
 * API for retrieving dashboard statistics (goals, charts, market data)
 *
 * The version of the OpenAPI document: 2.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ChartTypeEnum } from './ChartTypeEnum';
import {
    ChartTypeEnumFromJSON,
    ChartTypeEnumFromJSONTyped,
    ChartTypeEnumToJSON,
    ChartTypeEnumToJSONTyped,
} from './ChartTypeEnum';
import type { ChartFilterDto } from './ChartFilterDto';
import {
    ChartFilterDtoFromJSON,
    ChartFilterDtoFromJSONTyped,
    ChartFilterDtoToJSON,
    ChartFilterDtoToJSONTyped,
} from './ChartFilterDto';
import type { AxisConfigDto } from './AxisConfigDto';
import {
    AxisConfigDtoFromJSON,
    AxisConfigDtoFromJSONTyped,
    AxisConfigDtoToJSON,
    AxisConfigDtoToJSONTyped,
} from './AxisConfigDto';
import type { ChartSeriesDto } from './ChartSeriesDto';
import {
    ChartSeriesDtoFromJSON,
    ChartSeriesDtoFromJSONTyped,
    ChartSeriesDtoToJSON,
    ChartSeriesDtoToJSONTyped,
} from './ChartSeriesDto';

/**
 * Complete chart data configuration
 * @export
 * @interface ChartDataDto
 */
export interface ChartDataDto {
    /**
     * Unique identifier for this chart
     * @type {string}
     * @memberof ChartDataDto
     */
    id: string;
    /**
     * Display title for the chart
     * @type {string}
     * @memberof ChartDataDto
     */
    title: string;
    /**
     * Optional description or subtitle
     * @type {string}
     * @memberof ChartDataDto
     */
    description?: string;
    /**
     * 
     * @type {ChartTypeEnum}
     * @memberof ChartDataDto
     */
    chartType: ChartTypeEnum;
    /**
     * Data series for this chart
     * @type {Array<ChartSeriesDto>}
     * @memberof ChartDataDto
     */
    series: Array<ChartSeriesDto>;
    /**
     * 
     * @type {AxisConfigDto}
     * @memberof ChartDataDto
     */
    xAxis?: AxisConfigDto;
    /**
     * 
     * @type {AxisConfigDto}
     * @memberof ChartDataDto
     */
    yAxis?: AxisConfigDto;
    /**
     * Available filters for this chart
     * @type {Array<ChartFilterDto>}
     * @memberof ChartDataDto
     */
    filters?: Array<ChartFilterDto>;
    /**
     * Whether to display the legend
     * @type {boolean}
     * @memberof ChartDataDto
     */
    showLegend?: boolean;
    /**
     * Whether bars/areas should be stacked
     * @type {boolean}
     * @memberof ChartDataDto
     */
    stacked?: boolean;
    /**
     * Display order in the dashboard
     * @type {number}
     * @memberof ChartDataDto
     */
    order?: number;
}



/**
 * Check if a given object implements the ChartDataDto interface.
 */
export function instanceOfChartDataDto(value: object): value is ChartDataDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('title' in value) || value['title'] === undefined) return false;
    if (!('chartType' in value) || value['chartType'] === undefined) return false;
    if (!('series' in value) || value['series'] === undefined) return false;
    return true;
}

export function ChartDataDtoFromJSON(json: any): ChartDataDto {
    return ChartDataDtoFromJSONTyped(json, false);
}

export function ChartDataDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ChartDataDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'title': json['title'],
        'description': json['description'] == null ? undefined : json['description'],
        'chartType': ChartTypeEnumFromJSON(json['chartType']),
        'series': ((json['series'] as Array<any>).map(ChartSeriesDtoFromJSON)),
        'xAxis': json['xAxis'] == null ? undefined : AxisConfigDtoFromJSON(json['xAxis']),
        'yAxis': json['yAxis'] == null ? undefined : AxisConfigDtoFromJSON(json['yAxis']),
        'filters': json['filters'] == null ? undefined : ((json['filters'] as Array<any>).map(ChartFilterDtoFromJSON)),
        'showLegend': json['showLegend'] == null ? undefined : json['showLegend'],
        'stacked': json['stacked'] == null ? undefined : json['stacked'],
        'order': json['order'] == null ? undefined : json['order'],
    };
}

export function ChartDataDtoToJSON(json: any): ChartDataDto {
    return ChartDataDtoToJSONTyped(json, false);
}

export function ChartDataDtoToJSONTyped(value?: ChartDataDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'title': value['title'],
        'description': value['description'],
        'chartType': ChartTypeEnumToJSON(value['chartType']),
        'series': ((value['series'] as Array<any>).map(ChartSeriesDtoToJSON)),
        'xAxis': AxisConfigDtoToJSON(value['xAxis']),
        'yAxis': AxisConfigDtoToJSON(value['yAxis']),
        'filters': value['filters'] == null ? undefined : ((value['filters'] as Array<any>).map(ChartFilterDtoToJSON)),
        'showLegend': value['showLegend'],
        'stacked': value['stacked'],
        'order': value['order'],
    };
}

